import { useEffect } from 'react';

const useHorizontalScroll = (ref, enabled) => {
  useEffect(() => {
    if (enabled) {
      const el = ref.current;
      const listener = (e) => {
        const isHorizontalScrollPresent = el.scrollWidth > el.offsetWidth;
        if (isHorizontalScrollPresent) {
          e.preventDefault();
          el.scrollBy({ left: e.deltaY });
        }
      };

      el.addEventListener('mousewheel', listener);

      return () => {
        el.removeEventListener('mousewheel', listener);
      };
    }
  }, [ref, enabled]);
};

export default useHorizontalScroll;
